<mat-expansion-panel
  class="flotante-panel"
  [expanded]="expansionPanelExpanded"
  (expandedChange)="expansionPanelExpanded = $event"
>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon class="material-symbols-outlined">build</mat-icon>
      <span class="panel-title">Servicio técnico</span>
      <span class="counter-badge" matTooltip="Servicios pendientes">
        {{ totalEventos }}
      </span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <!-- BUSCADOR DE TÉCNICO -->
  <div class="seccion top-bar">
    <div class="buscador-wrapper">
      <mat-icon class="search-icon material-symbols-outlined">
        engineering
      </mat-icon>
      <input
        class="buscador-input"
        type="text"
        placeholder="Buscar técnico"
        [(ngModel)]="searchTecnico"
        [matAutocomplete]="auto"
      />
      @if (tecnicoSeleccionado) {
        <button
          irxBotonIcono
          tamano="mini"
          class="clear-btn"
          (mousedown)="limpiarTecnico()"
          tooltip="Quitar técnico"
        >
          <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
      }
    </div>
    <mat-autocomplete
      #auto
      [displayWith]="displayTecnico"
      (optionSelected)="onTecnicoSelected($event)"
    >
      @for (tecnico of tecnicosFiltrados; track tecnico._id) {
        <mat-option [value]="tecnico">
          <div class="dropdown-item-content">
            <mat-icon class="material-symbols-outlined item-icon">
              person
            </mat-icon>
            <span>{{ nombreTecnico(tecnico) }}</span>
            @if (vehiculoDeTecnico(tecnico)) {
              <span class="dropdown-vehiculo">
                · {{ vehiculoDeTecnico(tecnico) }}
              </span>
            }
          </div>
        </mat-option>
      }
      @if (tecnicosFiltrados.length === 0) {
        <mat-option disabled>
          <span class="dropdown-empty">Sin resultados</span>
        </mat-option>
      }
    </mat-autocomplete>
  </div>

  <!-- CAPAS -->
  <div class="seccion">
    <div class="seccion-titulo">Capas</div>
    <div class="capas-grid">
      @for (tipo of contadoresPorTipo; track tipo.key) {
        <button
          type="button"
          class="irx-chip irx-chip--multilinea capa-chip"
          [attr.aria-pressed]="tiposActivos.has(tipo.key)"
          (click)="toggleTipo(tipo.key)"
        >
          <mat-icon class="material-symbols-outlined">{{ tipo.icon }}</mat-icon>
          <span class="capa-label">{{ tipo.label }}</span>
          <span class="capa-count">{{ tipo.count }}</span>
        </button>
      }
      @if (mostrarVehiculos) {
        <button
          type="button"
          class="irx-chip irx-chip--multilinea capa-chip"
          [attr.aria-pressed]="tiposActivos.has('vehiculos')"
          (click)="toggleTipo('vehiculos')"
          tooltip="Vehículos con servicios pendientes"
        >
          <mat-icon class="material-symbols-outlined">directions_car</mat-icon>
          <span class="capa-label">Vehículos</span>
          <span class="capa-count">{{ vehiculosPendientesCount }}</span>
        </button>
        <button
          type="button"
          class="irx-chip irx-chip--multilinea capa-chip"
          [attr.aria-pressed]="tiposActivos.has('tecnicos')"
          (click)="toggleTipo('tecnicos')"
          tooltip="Vehículos con técnico"
        >
          <mat-icon class="material-symbols-outlined">engineering</mat-icon>
          <span class="capa-label">Técnicos</span>
          <span class="capa-count">{{ vehiculosTecnicos.length }}</span>
        </button>
      }
    </div>
  </div>
</mat-expansion-panel>
